module.exports = __webpack_public_path__ + "static/cg_role_260_00070189316.wav";